<footer>
  <div class="footer-main">
    <!-- Brand -->
    <div class="row">
      <div class="col-md-6 col-lg-3">
        <div class="logo">
          <img src="../../../../assets/image/flogo.png" alt="lcc" />
        </div>
        <p class="brand-desc">
          {{ t.text }}
        </p>
      </div>

      <!-- Quick Links -->
      <div class="footer-col col-md-6 col-lg-3">
        <h4>{{ t.QuickLinks }}</h4>
        <ul>
          <li>
            <a [routerLink]="['/', lang, 'aboutus']">{{ t.ABOUT }}</a>
          </li>
          <li>
            <a [routerLink]="['/', lang, 'services']">{{ t.Services }}</a>
          </li>
          <li>
            <a [routerLink]="['/', lang, 'subsidiaries']">{{
              t.Subsidiaries
            }}</a>
          </li>
        </ul>
      </div>

      <!-- Explore -->
      <div class="footer-col col-md-6 col-lg-3">
        <h4>{{ t.Explore }}</h4>
        <ul>
          <li>
            <a [routerLink]="['/', lang, 'equipment']">{{ t.Equipment }}</a>
          </li>
          <li>
            <a [routerLink]="['/', lang, 'contactus']">{{ t?.Contact }}</a>
          </li>
        </ul>
      </div>

      <!-- Contact -->
      <div class="footer-col col-md-6 col-lg-3">
        <h4>{{ t?.Contact }}</h4>
        <div class="contact-list">
          <div class="contact-item">
            <svg
              width="15"
              height="15"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#ccc"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <rect x="2" y="4" width="20" height="16" rx="2" />
              <path d="M2 7l10 7 10-7" />
            </svg>
            <a href="mailto:Info@lcc-libya.com">{{ email }}</a>
          </div>
          <div class="contact-item">
            <svg
              width="15"
              height="15"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#ccc"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path
                d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"
              />
              <circle cx="12" cy="9" r="2.5" />
            </svg>
            <span>{{ t?.location }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Bottom bar -->
  <div class="footer-bottom">
    <p>© 2026 LCC – Libyan Construction Company. All rights reserved.</p>
  </div>
</footer>
